// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  REGISTRY_INVOICE_FIELD,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { getResourceIdXML } from "helpers/form_helper";
import { toastWarningIsAllStore } from "helpers/utils";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  downloadXmlRegistryInvoices,
  getListRegistryInvoices,
  releaseRegistryInvoices,
  resetCreateRegistryInvoices,
  resetDownloadXmlRegistryInvoices,
  resetEditRegistryInvoices,
  resetListRegistryInvoices,
  resetReleaseRegistryInvoices,
  setColumnVisibleRegistryInvoices,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  CREATE_REGISTRY_INVOICES_FAIL,
  CREATE_REGISTRY_INVOICES_SUCCESS,
  DOWNLOAD_XML_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS,
  EDIT_REGISTRY_INVOICES_FAIL,
  EDIT_REGISTRY_INVOICES_SUCCESS,
} from "store/data-format/actionTypes";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getRegistryStatus } from "../helper/functionHelper";
import ErrorReleaseModal from "../modal/ErrorReleaseModal";
import HistoryTransferModal from "../modal/HistoryTransferModal";
import PDFViewModal from "../modal/PDFViewDownloadModal";
import SignHSMModal from "../modal/SignHSMModal";
import TypeSignDigitalModal from "../modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "../modal/VerifyPinUSBModal";
import { MODE_FORM, tableFormateDate } from "../utils";
import DetailData from "./DetailData";

const ListData = props => {
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);
  // modalErrorRelease
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // Release modal
  const [idRelease, setIdRelease] = useState(null);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [modalRelease, setModalRelease] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const toggleReleaseModal = () => setModalRelease(!modalRelease);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);
  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const dataFormat = useSelector(state => state.dataFormat);
  const { fileDownload, fileDownloadName, type } = dataFormat;
  const { loading, listData, totalCount, columnsVisible, params } =
    dataFormat.registryInvoices;

  const { t, i18n } = useTranslation(["registryInvoice"]);

  const [commonStatus, setCommonStatus] = useState(getRegistryStatus(t));

  useEffect(() => {
    setCommonStatus(getRegistryStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (type) {
      case CREATE_REGISTRY_INVOICES_SUCCESS:
        addToast(t("form.submit.create.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListRegistryInvoices(params));
        dispatch(resetCreateRegistryInvoices());
        break;
      case CREATE_REGISTRY_INVOICES_FAIL:
        addToast(t("form.submit.create.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateRegistryInvoices());
        break;

      case EDIT_REGISTRY_INVOICES_SUCCESS:
        addToast(t("form.submit.edit.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListRegistryInvoices(params));
        dispatch(resetEditRegistryInvoices());
        break;
      case EDIT_REGISTRY_INVOICES_FAIL:
        addToast(t("form.submit.edit.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetEditRegistryInvoices());
        break;
      case DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlRegistryInvoices());
        break;
      }
      case DOWNLOAD_XML_REGISTRY_INVOICES_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlRegistryInvoices());
        break;
      default:
        break;
    }
  }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    tenantCodeHeader,
    finalBuInfo,
    buStoreHeader,
  } = Dashboard;

  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      dispatch(getListRegistryInvoices(params));
    }
  }, [finalBuInfo]);

  // Action list chang tenantCode
  //   useEffect(() => {
  //     if (tenantCodeHeader) {
  //       params.page = 1;
  //       dispatch(getListRegistryInvoices(params));
  //     }
  //   }, [tenantCodeHeader]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);

  useEffect(() => {
    initColumn();
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
    return () => {
      dispatch(resetListRegistryInvoices());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      //   setDataDetail({
      //     content: row.content,
      //     file_name: row.file_name,
      //     process_upload_id: row.id,
      //     status: row.status,
      //   });
      setDataDetail({ id: row.id, mode: MODE_FORM.VIEW });
      toggleViewDetailModal();
    },
  };
  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };
  const listRowAction = [
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: t("action.edit"),
      conditionVisible: {
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        setDataDetail({ id: row.id, mode: MODE_FORM.EDIT });
        setIdRelease(row.id);
        toggleViewDetailModal();
      },
    },
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      isDropdown: true,
      classDropdown: "dropdown-menu-3",
      conditionVisible: {
        // auth_status: [AUTH_STATUS_APPROVE],
        resource_list: [],
      },
      listDropdown: [
        {
          text: "Phản hồi tiếp nhận (Mltdiep102)",
          icon: <i className="bx bxs-file text-primary" />,
          conditionVisible: {
            isHaveMltdiep102: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(
              row.resource_list,
              "tct-response",
              "102"
            );
            if (resource_id) {
              dispatch(
                downloadXmlRegistryInvoices(
                  resource_id,
                  `Mltdiep102_${row[REGISTRY_INVOICE_FIELD.COMMON.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
        {
          text: "Phản hồi phê duyệt (Mltdiep103)",
          icon: <i className="bx bxs-file text-info" />,
          conditionVisible: {
            isHaveMltdiep103: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(
              row.resource_list,
              "tct-response",
              "103"
            );
            if (resource_id) {
              dispatch(
                downloadXmlRegistryInvoices(
                  resource_id,
                  `Mltdiep103_${row[REGISTRY_INVOICE_FIELD.COMMON.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
        {
          text: "Tờ khai đã ký",
          icon: <i className="bx bxs-file text-success" />,
          conditionVisible: {
            isHaveSigned: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(row.resource_list, "signed");
            if (resource_id) {
              dispatch(
                downloadXmlRegistryInvoices(
                  resource_id,
                  `Signed_${row[REGISTRY_INVOICE_FIELD.COMMON.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
        {
          text: "Tờ khai chưa ký",
          icon: <i className="bx bxs-file text-default" />,
          conditionVisible: {
            isHaveRaw: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(row.resource_list, "raw");
            if (resource_id) {
              dispatch(
                downloadXmlRegistryInvoices(
                  resource_id,
                  `Raw_${row[REGISTRY_INVOICE_FIELD.COMMON.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
      ],
      text: "Download XML",
    },
    // {
    //   icon: <i className="bx bx-download font-size-18 text-primary" />,
    //   text: "Download XML",
    //   conditionVisible: {
    //     auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
    //   },
    //   onClick: row => {
    //     let resource_id = null;
    //     let type = "";
    //     if (row.auth_status === AUTH_STATUS_NEW) {
    //       type = "raw";
    //     } else if (row.auth_status === AUTH_STATUS_RR) {
    //       type = "tct-response";
    //     } else {
    //       type = "signed";
    //     }
    //     resource_id = getResourceIdXML(row.resource_list, type);
    //     if (resource_id) {
    //       dispatch(
    //         downloadXmlRegistryInvoices(
    //           resource_id,
    //           row[REGISTRY_INVOICE_FIELD.COMMON.TEN.field]
    //         )
    //       );
    //     } else {
    //       addToast("Tải xuống thất bại", {
    //         appearance: "error",
    //         autoDismiss: true,
    //       });
    //     }
    //   },
    // },
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Phát hành tờ khai",
      conditionVisible: {
        resource_id: [],
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        if (toastWarningIsAllStore(addToast)) {
          return;
        }
        setTransferData({
          id: row.id,
          mst: row.mst,
          resource_id: getResourceIdXML(row.resource_list, "raw"),
          type: TYPE_TRANSFER.REGISTER,
        });
        toggleTypeSignModal();
      },
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      onClick: row => {
        showPdfById(row.id);
      },
    },
    // {
    //   icon: <i className="bx bx-send font-size-18 text-success" />,
    //   text: "Phát hành tờ khai",
    //   conditionVisible: {
    //     auth_status: [AUTH_STATUS_NEW],
    //   },
    //   onClick: row => {
    //     setIdRelease(row.id);
    //     toggleReleaseModal();
    //   },
    // },
  ];

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    // {
    //   dataField: "pban",
    //   text: t("field.pban"),
    //   hidden: false,
    //   filter: textFilter({
    //     placeholder: t("placeholder.enter"),
    //   }),
    // },
    {
      dataField: "ten",
      text: t("field.ten"),
      hidden: false,
      formatter: (cellContent, row) => (
        <div style={{ width: "200px", whiteSpace: "initial" }}>{row.ten}</div>
      ),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    // },
    {
      dataField: "mccqt",
      text: "MCCQT",
      hidden: false,
      formatter: (cellContent, row) => (
        <div className="text-info fw-bold">{cellContent}</div>
      ),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px" },
      }),
    },
    {
      dataField: "mhso",
      text: "Mã hồ sơ",
      hidden: false,
      formatter: (cellContent, row) => (
        <div className="text-info fw-bold">{cellContent}</div>
      ),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px" },
      }),
    },
    {
      dataField: "lttxthuc",
      text: "Loại thông tin xác thực",
      hidden: false,
      formatter: (cellContent, row) => {
        let text = "";
        switch (cellContent) {
          case 1:
            text = "1 - Yêu cầu sinh trắc học";
            break;
          case 2:
            text = "2 - Yêu cầu xác thực OTP";
            break;
          default:
            text = "";
            break;
        }
        return <div className="text-primary fw-bold">{text}</div>;
      },
    },
    {
      dataField: "thxthuc",
      text: "Thời hạn xác thực",
      hidden: false,
      formatter: (cellContent, row) => {
        // 2025-06-12 15:58:40
        return (
          <div className="fw-bold">
            {cellContent
              ? tableFormateDate(new Date(cellContent).getTime() / 1000)
              : ""}
          </div>
        );
      },
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "mso",
      text: t("field.mso"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "hthuc",
      text: t("field.hthuc"),
      hidden: false,
      formatter: (cellContent, row) => {
        const value = OPTION_HTHUC.find(
          item => Number(item.value) === Number(row.hthuc)
        );
        return value ? value.label : "";
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterHTHUC,
      }),
    },
    {
      dataField: "tnnt",
      text: t("field.tnnt"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "mst",
      text: t("field.mst"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "cqtqly",
      text: t("field.cqtqly"),
      hidden: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "mcqtqly",
      text: t("field.mcqtqly"),
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "nlhe",
      text: t("field.nlhe"),
      hidden: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "dclhe",
      text: t("field.dclhe"),
      hidden: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "dctdtu",
      text: t("field.dctdtu"),
      hidden: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "dtlhe",
      text: t("field.dtlhe"),
      hidden: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ddanh",
      text: t("field.ddanh"),
      hidden: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "nlap",
      text: t("field.nlap"),
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.nlap),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "maker_date",
      text: t("field.maker_date"),
      hidden: true,
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.maker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "maker.display_name",
      text: t("field.maker_id"),
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      hidden: true,
    },
    {
      dataField: "checker_date",
      text: t("field.checker_date"),
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "checker.display_name",
      text: t("field.checker_id"),
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      hidden: true,
    },
    // {
    //   dataField: "resource_id",
    //   text: "resource_id",
    //   sort: true,
    // },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListRegistryInvoices(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListRegistryInvoices(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleRegistryInvoices(field, value));
  };

  return (
    <React.Fragment>
      <DetailData
        dataDetail={dataDetail}
        isOpen={modalDetail}
        t={t}
        i18n={i18n}
        toggleReleaseModal={toggleReleaseModal}
        toggle={toggleViewDetailModal}
      />
      {/* Hình thức ký modal */}
      <TypeSignDigitalModal
        t={t}
        isOpen={modalTypeSign}
        downloadXmlFunc={downloadXmlRegistryInvoices}
        transferData={transferData}
        toggle={toggleTypeSignModal}
        toggleUSBSignModal={toggleUSBSignModal}
        toggleHSMSignModal={toggleHSMSignModal}
      />
      {/* Ký USB Modal */}
      <VerifyPinUSBModal
        t={t}
        isOpen={modalUSBSign}
        transferData={transferData}
        resetDataFunc={getListRegistryInvoices}
        params={params}
        toggle={toggleUSBSignModal}
      />
      {/* PDFViewModal */}
      <PDFViewModal
        isOpen={modalPdfView}
        dataViewDocument={dataViewDocument}
        toggle={togglePdfViewModal}
      ></PDFViewModal>
      {/* Ký HSM Modal */}
      <SignHSMModal
        t={t}
        isOpen={modalHSMSign}
        transferData={transferData}
        resetDataFunc={getListRegistryInvoices}
        releaseFunc={releaseRegistryInvoices}
        resetReleaseFunc={resetReleaseRegistryInvoices}
        params={params}
        toggle={toggleHSMSignModal}
      />
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={"registry-invoices"}
      />
      {/* HistoryTransferModal */}
      <HistoryTransferModal
        isOpen={modalHistoryTransfer}
        toggle={toggleHistoryTransferModal}
        id={idHistory}
        path={"registry-invoices"}
      />
      {/* <PDFViewModal
        isOpen={modalUSBSign}
        toggle={toggleViewDocumentModal}
      ></PDFViewModal> */}
      {/* Release modal */}
      {/* <ConfirmModal
        isOpen={modalRelease}
        titleHeader={t("modal.release.header")}
        titleBody={t("modal.release.body")}
        onConfirm={value => {
          dispatch(releaseRegistryInvoices(idRelease));
        }}
        textBtnConfirm={t("modal.release.btnConfirm")}
        textBtnCancel={t("modal.release.btnCancel")}
        toggle={toggleReleaseModal}
      /> */}
      <div className="page-content">
        <MetaTags>
          <title>{t("title.registryInvoice")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={t("title.registryInvoice") + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      keyField="id"
                      data={listData?.map(item => ({
                        ...item,
                        isHaveMltdiep102: item.resource_list.some(
                          item => item.mltdiep === "102"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveMltdiep103: item.resource_list.some(
                          item => item.mltdiep === "103"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveSigned: item.resource_list.some(
                          item => item.type === "signed"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveRaw: item.resource_list.some(
                          item => item.type === "raw"
                        )
                          ? "TRUE"
                          : "FALSE",
                      }))}
                      columns={columns}
                      page={params.page}
                      listRowAction={
                        isRoleStore
                          ? listRowAction.filter(
                              item => item.text !== "Phát hành tờ khai"
                            )
                          : listRowAction
                      }
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          if (toastWarningIsAllStore(addToast)) {
                            return;
                          }
                          setDataDetail({ mode: MODE_FORM.ADD });
                          toggleViewDetailModal();
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        {t("button.add")}
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
